import type { PayloadAction } from "@reduxjs/toolkit";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { IReduxRequestNode } from "@litres-libs/types";
import { Request } from "../../../request/Request";
import { addHydrateReducer } from "../../../utils/hydrateReducer";

export interface IBonusDaily {
  expDate: string;
  sum: number;
}

type TUpdateSpamCSRFNode = IReduxRequestNode<
  null,
  IGetBonusExpirationGUJResponse
>;

interface IUserBonusesState {
  bonusExpiration: IBonusDaily[];
  actions: {
    getBonusExpirationGUJ: TUpdateSpamCSRFNode;
  };
}

const initialState: IUserBonusesState = {
  bonusExpiration: [],
  actions: {
    getBonusExpirationGUJ: {},
  },
};

interface IGetBonusExpirationGUJResponse {
  bonusExpiration: IBonusDaily[];
}

export const getBonusExpirationGUJ = createAsyncThunk(
  "pages/personalCabinet/getBonusExpirationGUJ",
  async () => {
    const response = new Request.GUJ<null, IGetBonusExpirationGUJResponse>({
      url: "/pages/personal_cabinet_my_bonus/?lite=1&gu_ajax=1",
      provider: {
        id: "GET_BONUS_EXPIRATION",
      },
      request: {
        method: "GET",
      },
    });

    return await response.fetch();
  }
);

export const bonusesSlice = createSlice({
  name: "user/bonusesSlice",
  initialState,
  reducers: {
    setBonusesExpiration: (
      state: IUserBonusesState,
      action: PayloadAction<IBonusDaily[]>
    ) => {
      state.bonusExpiration = action.payload;
    },
  },
  extraReducers: builder => {
    addHydrateReducer(builder, "pages.personalCabinet.bonuses");
    // Загрузка
    builder.addCase(
      getBonusExpirationGUJ.pending,
      (state: IUserBonusesState) => {
        state.actions.getBonusExpirationGUJ.isLoading = true;
      }
    );
    // Ответ
    builder.addCase(
      getBonusExpirationGUJ.fulfilled,
      (
        state: IUserBonusesState,
        action: PayloadAction<TUpdateSpamCSRFNode>
      ) => {
        state.actions.getBonusExpirationGUJ = action.payload;
        state.actions.getBonusExpirationGUJ.isLoading = false;

        if (action.payload.response?.bonusExpiration?.length) {
          state.bonusExpiration = action.payload.response.bonusExpiration;
        }

        // TODO: Ошибку точно не надо как-то визуально обработать в интерфейсе?
        if (action.payload.error) {
          console.error(
            "Ошибка запроса getBonusExpirationGUJ",
            action.payload.error
          );
          state.actions.getBonusExpirationGUJ.error = action.payload.error;
        }
      }
    );
  },
});

export const { setBonusesExpiration } = bonusesSlice.actions;

export default bonusesSlice.reducer;
